import Vue from 'vue';
import Vuex from 'vuex';
import { getStoreModules } from 'shared/core/utils';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: getStoreModules(),
});
